import { useCopilotTool } from '@customerio/hydra-copilot/react';
import { cache } from '@customerio/hydra-nav-state';

export function BashTool() {
  useCopilotTool({
    type: 'server',
    name: 'bash',
    handler({ response, wasApproved }) {
      if (response?.error != null) {
        return;
      }

      if (wasApproved === true) {
        cache.invalidate({ type: 'all' });
      }
    },
  });

  return null;
}
